"use client"

import { ColumnDef } from "@tanstack/react-table"
import { ArrowUpDown } from "lucide-react"
import { Button } from "@/components/ui/button"

import { Checkbox } from "@/components/ui/checkbox"
import PermissionRowActions from "./PermissionRowActions"
import { format } from "date-fns"


export type Permissions = {
    id: string
    name: string
    guard_name: string
    created_at: Date
    updated_at: Date
}
interface rowActionProps {
    onEdit: (data: any) => void;
    roles: string[]
}

export const permissionsColumns = ({ onEdit, roles }: rowActionProps): ColumnDef<Permissions>[] => {
    const columns: ColumnDef<Permissions>[] = [

        {
            accessorKey: "id",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        id
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
        },
        {
            accessorKey: "name",
            header: "Name",
        },
        {
            accessorKey: "created_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Created At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const formattedDate = format(new Date(row.original.created_at), 'yyyy-MM-dd HH:mm:ss');
                return <span>{formattedDate}</span>
            },
        },
        {
            accessorKey: "updated_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Updated At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const formattedDate = format(new Date(row.original.updated_at), 'yyyy-MM-dd HH:mm:ss');
                return <span>{formattedDate}</span>
            },
        },
    ]

    if (roles.includes('permission-edit')) {
        columns.push({
            id: "actions",
            header: 'Actions',
            cell: ({ row }) => <PermissionRowActions row={row} onEdit={onEdit} roles={roles} />,
        })
    }
    return columns
}
